import { render, staticRenderFns } from "./RecomendationList.vue?vue&type=template&id=6c9324c7&"
import script from "./RecomendationList.vue?vue&type=script&lang=js&"
export * from "./RecomendationList.vue?vue&type=script&lang=js&"
import style0 from "./RecomendationList.vue?vue&type=style&index=0&id=6c9324c7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports